import React, { Component, SyntheticEvent } from 'react'
import Select from 'react-select'

class ICSelect extends Component {

  state = {
    focused: false
  }

  render() {
    const {
      title,
      onFocus,
      onBlur,
      className,
      error,
      touched,
      showErrors,
      searchable,
      ...passThroughProps
    } = this.props
    const uxCompliantShowErrors = !this.state.focused && showErrors && error

    return (
      <div className={uxCompliantShowErrors ? `bp3-intent-danger ${className}` : `${className}`}>
        {title &&
          <label className={`bp3-label ${this.props.description? 'with-desc' : ''}`}>{title}
          {this.props.description && <label className="bp3-label description">{this.props.description}</label>}
          </label>
        }
        <div className="dropdown-container">
          <Select
            {...passThroughProps}
            className={`project-input`}
            clearable={false}
            onBlur={(e) => {
              onBlur && onBlur(e)
              this.setState({ focused: false })
            }}
            onFocus={(e) => {
              onFocus && onFocus(e)
              this.setState({ focused: true })
            }}
            closeOnSelect={!this.props.multi}
            searchable={searchable || false}
          />
          {!error && touched && <i className="im-checkmark3"/>}
        </div>
        {uxCompliantShowErrors && <div className="bp3-form-helper-text">{error}</div>}
      </div>
    )
  }
}

export default ICSelect
